exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__Scouting__emptyActivities__cMsIg {\n  padding: 12px 0 36px;\n  text-align: center;\n}\n\n", ""]);

// exports
exports.locals = {
	"emptyActivities": "dmb-web__Scouting__emptyActivities__cMsIg"
};